import {
    AVISOS,
    COUNTRIES,
    LOADING_COUNTRIES,
    PLANES_GESTION,
    REINICIO,
    SELECTED_COUNTRY,
    TIPOS_MATERIAS
} from '../types';
import {AppEnv} from '../../../components/env';
import axios from 'axios';
import {alertFail} from "../../../components/Global-W/NewFunctions";

const apiUrl = AppEnv.apiGes;

export function setLoading(data) {
    return {
        type: LOADING_COUNTRIES,
        payload: data
    };
}

// <=<●>=><=<●>=><=<●>=> Countries <=<●>=><=<●>=><=<●>=>
export function fetchCountries() {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(setLoading(true));
            axios.get(apiUrl + 'countries/get/1', {
                    method: 'get', headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            ).then((response) => {
                dispatch(fetchCountriesSuccess(response.data));
                resolve(response.data);
            }).catch(error => {
                dispatch(fetchCountriesFailed());
                resolve(error);
            });
        });
    };
}

export function fetchCountriesSuccess(response) {
    return {
        type: COUNTRIES,
        payload: response
    };
}

export function fetchCountriesFailed() {
    alertFail();
    return {
        type: COUNTRIES,
        payload: []
    };
}

export function setCountry(country) {
    return {
        type: SELECTED_COUNTRY,
        payload: country
    };
}

// <=<●>=><=<●>=><=<●>=> Tipo Materias <=<●>=><=<●>=><=<●>=>
export function fetchTiposMaterias(country) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'tipo/materia/get/' + country, {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        ).then((response) => {
            dispatch(fetchTiposMateriasSuccess(response.data));
        }).catch(error => {
            dispatch(fetchTiposMateriasFailed());
        });
    };
}

export function fetchTiposMateriasSuccess(response) {
    return {
        type: TIPOS_MATERIAS,
        payload: response
    };
}

export function fetchTiposMateriasFailed() {
    alertFail();
    return {
        type: TIPOS_MATERIAS,
        payload: []
    };
}

export function fetchPlanesGestion(token, country, nivel, tipoNivel) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'planes/get/' + country + '/' + nivel + '/' + tipoNivel, {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            dispatch(fetchPlanesGestionSuccess(response.data));
        }).catch(error => {
            dispatch(fetchPlanesGestionFailed());
        });
    };
}

export function fetchPlanesGestionSuccess(response) {
    return {
        type: PLANES_GESTION,
        payload: response
    };
}

export function fetchPlanesGestionFailed() {
    alertFail();
    return {
        type: PLANES_GESTION,
        payload: []
    };
}

// <=<●>=><=<●>=><=<●>=> Countries <=<●>=><=<●>=><=<●>=>
export function fetchAvisos(escuela, puesto) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'avisos/school/' + escuela + '/' + puesto, {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        ).then((response) => {
            dispatch(fetchAvisosSuccess(response.data));
        }).catch(error => {
            dispatch(fetchAvisosFailed());
        });
    };
}

export function fetchAvisosSuccess(response) {
    return {
        type: AVISOS,
        payload: response
    };
}

export function fetchAvisosFailed() {
    alertFail();
    return {
        type: AVISOS,
        payload: []
    };
}

export function fetchReinicioSistema() {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'avisos/reinicio', {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        ).then((response) => {
            dispatch(fetchReinicioSistemaSuccess(response.data));
        }).catch(error => {
            dispatch(fetchReinicioSistemaFailed());
        });
    };
}

export function fetchReinicioSistemaSuccess(response) {
    return {
        type: REINICIO,
        payload: response.descripcion !== undefined ? JSON.parse(response.descripcion) : []
    };
}

export function fetchReinicioSistemaFailed() {
    alertFail();
    return {
        type: REINICIO,
        payload: []
    };
}


